/**
 * Operations Module Routes
 * Defines all routes for the operations module
 */

import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

// Lazy load all pages for better performance
const OperationsDashboard = lazy(() => import('../pages/Dashboard/OperationsDashboard'));
const UserAccessPage = lazy(() => import('../pages/UserAccess/UserAccessPage'));
const WorkflowEditsPage = lazy(() => import('../pages/WorkflowEdits/WorkflowEditsPage'));
const FinancePage = lazy(() => import('../pages/Finance/FinancePage'));
const PaymentsPage = lazy(() => import('../pages/Payments/PaymentsPage'));
const RemittancePage = lazy(() => import('../pages/Remittance/RemittancePage'));
const MasterEditsPage = lazy(() => import('../pages/MasterEdits/MasterEditsPage'));
const DataMappingPage = lazy(() => import('../pages/DataMapping/DataMappingPage'));
const ReportsPage = lazy(() => import('../pages/Reports/ReportsPage'));

export const operationsRoutes: RouteObject[] = [
  {
    path: 'operations',
    children: [
      {
        index: true,
        element: <OperationsDashboard />
      },
      {
        path: 'user-access',
        element: <UserAccessPage />
      },
      {
        path: 'workflow-edits',
        element: <WorkflowEditsPage />
      },
      {
        path: 'finance',
        element: <FinancePage />
      },
      {
        path: 'payments',
        element: <PaymentsPage />
      },
      {
        path: 'remittance',
        element: <RemittancePage />
      },
      {
        path: 'master-edits',
        element: <MasterEditsPage />
      },
      {
        path: 'data-mapping',
        element: <DataMappingPage />
      },
      {
        path: 'reports',
        element: <ReportsPage />
      }
    ]
  }
];

export default operationsRoutes;
